import { Injector } from "@angular/core";
import { Art57Node } from "../Art57Node";
import { SubstanceAlias } from "../../../Data/Art57Data/SubstanceAlias";
import { FieldDefinition } from "../../../../../sections/createSendProductReport/message/fieldDefinition";
import { Art57NodeUtils } from "../Art57NodeUtils";
import { TreeNodeSubstanceAliasTranslationsList } from "../ListEntity/TreeNodeSubstanceAliasTranslationsList";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { ErrorControlUtil } from "../../../ErrorControlUtil";
import { environment } from "../../../../../../environments/environment";

export class TreeNodeSubstanceAlias extends Art57Node {
    constructor(injector: Injector, parent: Art57Node) {
      super(
        injector,
        new SubstanceAlias(new FieldDefinition(injector)),
        'Substance Alias'
      );
  
      this.parent = parent;
      this.labelNodeName = 'Substance Alias';
      this.ioc!.get(Art57Section).generateNumColumValue(this);
      this.refreshLabel();
    }
  
    override refreshLabel(): void {
      if (this.data && this.data.model && this.data.model.aliasname) {
        this.label = this.data.model.aliasname;
      } else {
        this.label = this.labelTemplate;
      }
    }
  
    override getMessage(): any {
      //Substance Alias level
      let substancealias: any = {};
  
      if (this.data.model) {
        substancealias = { ...this.data.model };
      }
  
      //Substance Alias children
      let childrenModel: any = {};
      this.children?.forEach((node) => {
        let authorisedProductChild = node as Art57Node;
        let art57Message = authorisedProductChild.getMessage();
        if (art57Message != null) {
          childrenModel = { ...childrenModel, ...art57Message };
        }
      });
  
      if (childrenModel) {
        substancealias = { ...substancealias, ...childrenModel };
      }
  
      return substancealias;
    }

    
    override setMessage(jsonObject: any): void {
      if (jsonObject.aliastranslations) {
          Art57NodeUtils.importNodeType(this,jsonObject.aliastranslations, 'aliastranslation',TreeNodeSubstanceAliasTranslationsList);
      }
      
      super.setMessage(jsonObject);     
    }
    
    override getListItem(): any[] {
      return [
        this.data.model &&
          this.data.model.sourcecode &&
          this.data.model.sourcecode.name
          ? this.data.model.sourcecode.name
          : 'Not selected',
        this.data.model && this.data.model.aliasname
          ? this.data.model.aliasname
          : 'Not selected',
      ];
    }
  
    override cloneNode(newParent: Art57Node): Art57Node|undefined {
      let clonedNode: TreeNodeSubstanceAlias = new TreeNodeSubstanceAlias(
        this.ioc!,
        newParent
      );
  
      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

  
      this.children?.forEach((child) => {
        let childToClone = child as Art57Node;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
  
      return clonedNode;
    }

    override validateBusinessRules(): any[] {
      const sameModelValuesBusinessErrors = ErrorControlUtil.sameModelValues(this);
      let businessRulesErrors = [];

      if (sameModelValuesBusinessErrors.length>0){
        businessRulesErrors.push(...sameModelValuesBusinessErrors);
      }

       return businessRulesErrors;
    }
  }
  